import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listSuppliers, type Supplier } from '@/lib/api/suppliers.js';
import { NewSupplierModal } from './NewSupplierModal.js';

type Props = {
  value: string;
  onChange: (supplierId: string, supplier?: Supplier) => void;
  required?: boolean;
  className?: string;
  id?: string;
};

export function SupplierSelect({ value, onChange, required, className, id }: Props) {
  const [newOpen, setNewOpen] = useState(false);
  const suppliersQuery = useQuery({
    queryKey: ['suppliers-active'],
    queryFn: () => listSuppliers({ active: true }),
  });

  return (
    <>
      <div className="flex gap-2">
        <select
          id={id}
          className={className ?? 'w-full rounded-xl border px-3 py-2'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
        >
          <option value="">Select supplier…</option>
          {(suppliersQuery.data ?? []).map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="shrink-0 rounded-xl border border-primary/30 px-3 py-2 text-sm font-semibold text-primary hover:bg-primary/5"
          onClick={() => setNewOpen(true)}
        >
          + New
        </button>
      </div>
      <NewSupplierModal
        open={newOpen}
        onClose={() => setNewOpen(false)}
        onCreated={(s) => onChange(s.id, s)}
      />
    </>
  );
}
